import React from 'react';
import classNames from 'classnames';
import Goget from '../../assets/tableSectionImages/goget.png';
import CarNextDoor from '../../assets/tableSectionImages/cnd.png';
import Avis from '../../assets/tableSectionImages/avis.png';
import CheckIcon from '../../assets/tableSectionImages/check-circle-solid.svg';
import IconCancel from '../../assets/tableSectionImages/Icon-cancel.svg';
import Star from '../../assets/tableSectionImages/star.svg';
import LeftBg from '../../assets/tableSectionImages/tableSectionLeftBg.svg';
import RightBg from '../../assets/tableSectionImages/tableSectionRightBg.svg';
import Trustpilotbrandmark from '../../assets/tableSectionImages/Trustpilot_brandmark.png';
import DriveMateLogo from '../../assets/tableSectionImages/DriveMateLogo.png';
import css from './LandingPageNew.css';

const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
const DOMAIN_HELP_URL = process.env.REACT_APP_DOMAIN_HELP_URL;

const ComparisonTable = () => {
  const tableContent = [
    {
      tableRowTitle: 'Rent by hour, day, month',
      isIcon: true,
      isDriveMate: true,
      driveMateText: null,
      driveMateComment: 'Rent by the hour, day or month',
      isGoget: true,
      gogetComment: 'Rent by hour, day or month',
      gogetText: null,
      isCarNextDoor: true,
      carNextDoorComment: 'Rent by the hour, day or month',
      carNextText: null,
      isAvis: false,
      avisComment: 'Rent by the day or month',
      avisText: null,
    },
    {
      tableRowTitle: 'Pricing',
      isIcon: false,
      isDriveMate: false,
      driveMateText: 79,
      driveMateComment: null,
      isGoget: false,
      gogetComment: 'Gostarter plan',
      gogetText: 94,
      isCarNextDoor: false,
      carNextDoorComment: null,
      carNextText: 91,
      isAvis: false,
      avisComment: false,
      avisText: 110,
    },
    {
      tableRowTitle: 'All inclusive pricing',
      isIcon: true,
      isDriveMate: true,
      driveMateText: null,
      driveMateComment: 'No booking fees, no subscription price, mileage included.',
      isGoget: false,
      gogetComment: 'Membership fees extra',
      gogetText: null,
      isCarNextDoor: false,
      carNextDoorComment: 'Mileage fees extra',
      carNextText: null,
      isAvis: false,
      avisComment: false,
      avisText: null,
    },
    {
      tableRowTitle: 'Open car with app',
      isIcon: true,
      isDriveMate: true,
      driveMateText: null,
      driveMateComment: 'Keyless access technology',
      isGoget: false,
      gogetComment: 'Smart card',
      gogetText: null,
      isCarNextDoor: false,
      carNextDoorComment: 'Lockbox',
      carNextText: null,
      isAvis: false,
      avisComment: false,
      avisText: null,
    },
    {
      tableRowTitle: 'Car Variety',
      isIcon: true,
      isDriveMate: true,
      driveMateText: null,
      driveMateComment: null,
      isGoget: true,
      gogetComment: null,
      gogetText: null,
      isCarNextDoor: true,
      carNextDoorComment: null,
      carNextText: null,
      isAvis: false,
      avisComment: false,
      avisText: null,
    },
    {
      tableRowTitle: '24x7 customer service',
      isIcon: true,
      isDriveMate: true,
      driveMateText: null,
      driveMateComment: null,
      isGoget: true,
      gogetComment: null,
      gogetText: null,
      isCarNextDoor: true,
      carNextDoorComment: null,
      carNextText: null,
      isAvis: false,
      avisComment: false,
      avisText: null,
    },
  ];

  return (
    <div className={css.tableSection}>
      <div className={css.tableBackground}>
        <div className={classNames(css.landingContainer)}>
          <h3 className={css.tableHead}>
            Drive mate offers more value and convenience than others - it’s a no-brainer!
          </h3>
        </div>
        <div className={css.leftImg}>
          <img src={LeftBg} alt="" />
        </div>
        <div className={css.rightImg}>
          <img src={RightBg} alt="" />
        </div>
      </div>
      <div className={classNames(css.landingContainer)}>
        <div className={css.tableContent}>
          <table>
            <tr>
              <th>
                <div className={css.flexRow}></div>
              </th>
              <th>
                <div className={classNames(css.flexRow, css.rowHead)}>
                  <img src={DriveMateLogo} alt="" />
                </div>
              </th>
              <th>
                <div className={classNames(css.flexRow, css.rowHead)}>
                  <img src={Goget} alt="" />
                </div>
              </th>
              <th>
                <div className={classNames(css.flexRow, css.rowHead)}>
                  <img src={CarNextDoor} alt="" />
                </div>
              </th>
              <th>
                <div className={classNames(css.flexRow, css.rowHead)}>
                  <img src={Avis} alt="" />
                </div>
              </th>
            </tr>
            {tableContent &&
              tableContent.length > 0 &&
              tableContent.map((content, index) => (
                <tr>
                  <td className={css.rowTitle}>
                    {content.tableRowTitle === 'Pricing' ? (
                      <>
                        Pricing
                        <a
                          style={{ display: 'block', textDecoration: 'underline', fontSize: 14 }}
                          href={`https://help.${DOMAIN_HELP_URL}/kb/en`}
                          target="_blank"
                        >
                          See full comparison
                        </a>
                      </>
                    ) : content.tableRowTitle === 'All inclusive pricing' ? (
                      <div className={classNames(css.flexRow, css.headerPointers)} style={{ textAlign: 'left' }}>
                        <span className={css.isIconWrapper}>
                          {content.tableRowTitle}
                          <i className={css.infoIcon}>?</i>
                          <div className={css.info}>{content.driveMateComment}</div>
                        </span>
                      </div>
                    ) : (
                      content.tableRowTitle
                    )}
                  </td>
                  <td>
                    <div className={css.flexRow}>
                      <span className={css.isIconWrapper}>
                        {content.isIcon ? (
                          <img src={content.isDriveMate ? CheckIcon : IconCancel} alt="" />
                        ) : (
                          <span className={css.literalText}>$</span>
                        )}
                        {content.driveMateComment && <i className={css.infoIcon}>?</i>}
                        {content.driveMateComment && (
                          <div className={css.info}>{content.driveMateComment}</div>
                        )}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={css.flexRow}>
                      <span className={css.isIconWrapper}>
                        {content.isIcon ? (
                          <img src={content.isGoget ? CheckIcon : IconCancel} alt="" />
                        ) : (
                          <span className={css.literalText}>$$</span>
                        )}
                        {content.gogetComment && <i className={css.infoIcon}>?</i>}
                        {content.gogetComment && (
                          <div className={css.info}>{content.gogetComment}</div>
                        )}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={css.flexRow}>
                      <span className={css.isIconWrapper}>
                        {content.isIcon ? (
                          <img src={content.isCarNextDoor ? CheckIcon : IconCancel} alt="" />
                        ) : (
                          <span className={css.literalText}>$$</span>
                        )}
                        {content.carNextDoorComment && <i className={css.infoIcon}>?</i>}
                        {content.carNextDoorComment && (
                          <div className={css.info}>{content.carNextDoorComment}</div>
                        )}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={css.flexRow}>
                      <div className={css.flexRow}>
                        <span className={css.isIconWrapper}>
                          {content.isIcon ? (
                            <img src={content.isAvis ? CheckIcon : IconCancel} alt="" />
                          ) : (
                            <span className={css.literalText}>$$$</span>
                          )}
                          {content.avisComment && <i className={css.infoIcon}>?</i>}
                          {content.avisComment && (
                            <div className={css.info}>{content.avisComment}</div>
                          )}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            {/* <tr>
              <td className={css.trust}>
                <img src={Trustpilotbrandmark} alt="" />
              </td>
              <td>
                <div className={css.flexRow}>
                  <img src={Star} alt="" />
                  <span className={css.isIconWrapper}>
                    <h6>4.7</h6>
                    <i className={css.infoIcon}>?</i>
                    <div className={css.info}>The score relates to Drive mate's parent company in Australia (Drive mate)</div>
                  </span>
                  <div className={css.info}>Based on Drive mate Australia score (Drive Mate)</div>
                </div>
              </td>
              <td>
                <div className={css.flexRow}>
                  <img src={Star} alt="" />
                  <h6>3.2</h6>
                </div>
              </td>
              <td>
                <div className={css.flexRow}>
                  <img src={Star} alt="" />
                  <h6>1.6</h6>
                </div>
              </td>
              <td>
                <div className={css.flexRow}>
                  <img src={Star} alt="" />
                  <h6>1.4</h6>
                </div>
              </td>
            </tr> */}
          </table>
          <div className={css.lastUpdateText}>
            <p>*Last updated: 09/03/2022</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;
